import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, FlaskConical, CheckCircle2, Circle } from 'lucide-react';
import { DashboardShell } from '../layout/DashboardShell';
import { UserMenu } from '../components/UserMenu';
import { DashPanel } from '../components/DashPanel';
import { MetricStat } from '../components/MetricStat';
import { useAnalysis } from '../context/AnalysisContext';
import { AnalysisCard } from './AnalysisCard';

export function AnalysisHome() {
  const { analyses } = useAnalysis();
  const navigate = useNavigate();

  const completedCount = useMemo(
    () => analyses.filter((a) => a.status === 'concluida').length,
    [analyses]
  );

  return (
    <DashboardShell mode="analysis">
      <header className="shrink-0 px-6 py-4 flex items-center justify-between">
        <div>
          <h1 className="text-base font-semibold text-foreground">Análise de eventos</h1>
          <p className="text-xs text-muted-foreground mt-0.5">
            Compare eventos e prepare evidências para artigos científicos
          </p>
        </div>
        <UserMenu />
      </header>

      <div className="flex-1 overflow-y-auto p-6 space-y-8 bg-blue-100 dark:bg-background border-t border-l border-border rounded-tl-2xl">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <DashPanel padding="sm">
            <MetricStat icon={FlaskConical} label="Análises criadas" value={analyses.length} />
          </DashPanel>
          <DashPanel padding="sm">
            <MetricStat icon={CheckCircle2} label="Concluídas" value={completedCount} />
          </DashPanel>
          <DashPanel padding="sm">
            <MetricStat icon={Circle} label="Em rascunho" value={analyses.length - completedCount} />
          </DashPanel>
        </div>

        {/* análises criadas */}
        <section>
          <div className="flex items-baseline justify-between mb-4">
            <h2 className="text-sm font-semibold text-foreground">Suas análises</h2>
            <span className="text-xs text-muted-foreground">
              {analyses.length} análise{analyses.length === 1 ? '' : 's'}
            </span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <button
              type="button"
              onClick={() => navigate('/dashboard/analysis/new')}
              className="text-left h-full min-h-[160px]"
            >
              <DashPanel
                padding="sm"
                className="h-full flex flex-col items-center justify-center border-dashed hover:border-primary hover:bg-primary/5 transition-colors"
              >
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
                  <Plus className="h-6 w-6 text-primary" />
                </div>
                <p className="text-sm font-medium text-foreground">Criar análise</p>
                <p className="text-xs text-muted-foreground text-center mt-1">
                  Vincule eventos e defina o objetivo de pesquisa
                </p>
              </DashPanel>
            </button>
            {analyses.map((a) => (
              <AnalysisCard key={a.id} analysis={a} />
            ))}
          </div>
        </section>

      </div>
    </DashboardShell>
  );
}
